export const formatDateUTC = (
  date: string | Date,
  timeZone: string = "UTC",
  locale: string = "en-US",
  format: "standard" | "custom" = "standard",
  showRemainingDays = false,
  showTime = false,
  hideToday = false,
): string => {
  const dateObj = typeof date === "string" ? new Date(date) : date;
  if (isNaN(dateObj.getTime())) {
    throw new Error("Invalid date");
  }

  const offsetMinutes = dateObj.getTimezoneOffset(); // Offset in minutes
  const offsetHours = -offsetMinutes / 60; // Convert to hours
  const utcOffset = `UTC${offsetHours >= 0 ? ` +${offsetHours}` : offsetHours}`;

  let formattedDate;
  if (format === "standard") {
    formattedDate = new Intl.DateTimeFormat(locale, {
      timeZone,
      month: "short",
      day: "numeric",
      year: "numeric",
    }).format(dateObj);
  } else if (format === "custom") {
    const options: Intl.DateTimeFormatOptions = {
      timeZone,
      weekday: "short",
      day: "2-digit",
      month: "short",
    };
    formattedDate = new Intl.DateTimeFormat(locale, options).format(dateObj);
  } else {
    throw new Error(`Unsupported format: ${format}`);
  }

  if (showTime) {
    const timeString = new Intl.DateTimeFormat(locale, {
      timeZone,
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: false,
    }).format(dateObj);

    formattedDate += ` • ${timeString} ${utcOffset}`;
  }

  if (showRemainingDays) {
    const today = new Date();
    today.setUTCHours(0, 0, 0, 0); // Normalize to UTC
    const dueDateUTC = new Date(dateObj);
    dueDateUTC.setUTCHours(0, 0, 0, 0);

    const timeDiff = dueDateUTC.getTime() - today.getTime();
    const daysLeft = Math.ceil(timeDiff / (1000 * 60 * 60 * 24)); // Convert ms to days

    if (daysLeft === 0) {
      if (!hideToday) {
        formattedDate += " (today)";
      }
    } else if (daysLeft > 0) {
      formattedDate += ` (in ${daysLeft} days)`;
    } else {
      formattedDate += ` (${Math.abs(daysLeft)} days ago)`;
    }
  }

  return formattedDate;
};
